<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des subventions d'entreprise</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <modal :adaptive="true"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               height="auto"
               name="modal-fade">
          <v-card>
            <v-toolbar
                color="#01579B"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            readonly
                            rounded
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert :color="AlertColorS(typeS)"
                       :dismissible="true"
                       :value="true"
                       border="top"
                       class="pre-formatted multi-line"
                       colored-border
                       elevation="2"
                       icon="check_circle"
                       v-if="typeS">
                {{ text }}
              </v-alert>
              <v-container>
                <v-card-text>
                  <v-container>
                    <v-stepper v-model="e6" vertical>
                      <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                        Informations de la subvention
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-row>
                          <v-col cols="12">
                            <v-select :items="companies"
                                      :disabled="true"
                                      class="centered-input text-center"
                                      item-text="name"
                                      item-value="id"
                                      label="Entreprise"
                                      v-model="editedItem.companyId">
                              <template v-slot:selection="{ item }">
                                <div style="width: 100%; text-align: center !important;">
                                  {{ item.name }}
                                </div>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-select :items="modePlafondOptions"
                                      class="centered-input text-center"
                                      item-text="text"
                                      item-value="value"
                                      label="Mode plafond"
                                      v-model="editedItem.modePlafond">
                            </v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Nombre de repas par mois"
                                          type="number"
                                          v-model.number="editedItem.nombreRepasParMois"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Plafond journalier (FCFA)"
                                          type="number"
                                          v-model.number="editedItem.plafondJour"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Quote part entreprise (FCFA)"
                                          type="number"
                                          v-model.number="editedItem.quotePartCompany"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Montant recharge mensuelle (FCFA)"
                                          type="number"
                                          v-model.number="editedItem.montantRechargeMois"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-checkbox
                                v-model="editedItem.resetEnfOfMonth"
                                label="Remise à zéro mensuelle"
                                color="#01579B"
                                hide-details
                                class="mx-auto text-center">
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-checkbox
                                v-model="editedItem.allowedOrderNextMonth"
                                label="Autorisation commande mois suivant"
                                color="#01579B"
                                hide-details
                                class="mx-auto text-center">
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 2" class="mb-2 mt-6"
                               color="primary"><span
                            class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!FormIsValidModif && !loading" @click="updateSubvention()"
                         class="white--text"
                         color="#01579B" depressed>Modifier subvention
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </modal>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export subventions</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span> Création subvention </span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container>
                      <v-stepper v-model="e6" vertical>
                        <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                          Informations de la subvention
                        </v-stepper-step>
                        <v-stepper-content step="1">
                          <v-row>
                            <v-col cols="12">
                              <v-select :items="companies"
                                        class="centered-input text-center"
                                        item-text="name"
                                        item-value="id"
                                        label="Entreprise"
                                        v-model="editedItem.companyId">
                                <template v-slot:selection="{ item }">
                                  <div style="width: 100%; text-align: center !important;">
                                    {{ item.name }}
                                  </div>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-select :items="modePlafondOptions"
                                        class="centered-input text-center"
                                        item-text="text"
                                        item-value="value"
                                        label="Mode plafond"
                                        v-model="editedItem.modePlafond">
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Nombre de repas par mois"
                                            type="number"
                                            v-model.number="editedItem.nombreRepasParMois"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Plafond journalier (FCFA)"
                                            type="number"
                                            v-model.number="editedItem.plafondJour"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Quote part entreprise (FCFA)"
                                            type="number"
                                            v-model.number="editedItem.quotePartCompany"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Montant recharge mensuelle (FCFA)"
                                            type="number"
                                            v-model.number="editedItem.montantRechargeMois"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-checkbox
                                  v-model="editedItem.resetEnfOfMonth"
                                  label="Remise à zéro mensuelle"
                                  color="#01579B"
                                  hide-details
                                  class="mx-auto text-center">
                              </v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-checkbox
                                  v-model="editedItem.allowedOrderNextMonth"
                                  label="Autorisation commande mois suivant"
                                  color="#01579B"
                                  hide-details
                                  class="mx-auto text-center">
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-btn @click="e6 = 2" class="mb-2 mt-6"
                                 color="primary"><span
                              class="material-icons"> done_all </span></v-btn>
                        </v-stepper-content>
                      </v-stepper>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!FormIsValid && !loading" @click="createSubvention()"
                           class="white--text"
                           color="#01579B" depressed>Créer subvention
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "subvention",
  components: {HotTable},
  data: function () {
    return {
      companyIds: {},
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      modifier: "",
      typeS: null,
      elapse: null,
      type: null,
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      toObject: [],
      companies: [],
      modePlafondOptions: [
        { text: "Journalier", value: "JOURNALIER" },
        { text: "Mensuel", value: "MENSUEL" }
      ],
      editedItem: {
        id: "",
        companyId: "",
        nomEntreprise: "",
        plafondJour: 0,
        quotePartCompany: 0,
        montantRechargeMois: 0,
        resetEnfOfMonth: false,
        allowedOrderNextMonth: false,
        disabled: false,
        modePlafond: "JOURNALIER",
        nombreRepasParMois: 20,
        creationDate: ""
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.displayTitleModif(start.row)
                  window.updateData4Modif(start.row)
                  window.show()
                }, 0);
              }
            },
            sp1: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterOnCellMouseDown: this.afterOnCellMouseDownMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 9],
          indicators: false
        },
        colHeaders: [
          "Id", "Nom entreprise", "Mode plafond", "Nombre repas/mois", "Plafond journalier", "Quote part entreprise", "Montant recharge mensuelle", "Remise à zéro mensuelle",
          "Autorisation commande mois suivant", "Date de création", "Statut"
        ],
        columns: [
          {title: "Id", width: "10px", readOnly: true},
          {title: "Nom entreprise", width: "200px", readOnly: true},
          {
            title: "Mode plafond",
            width: "150px",
            type: "dropdown",
            source: ["JOURNALIER", "MENSUEL"],
            readOnly: false
          },
          {title: "Nombre repas/mois", width: "180px", type: "numeric"},
          {title: "Plafond journalier", width: "180px"},
          {title: "Quote part entreprise", width: "190px"},
          {title: "Montant recharge mensuelle", width: "250px"},
          {title: "Remise à zéro mensuelle", width: "210px", type: "checkbox"},
          {title: "Autorisation commande mois suivant", width: "300px", type: "checkbox"},
          {
            title: "Date de création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {
            title: "Statut",
            width: "120px",
            type: "dropdown",
            source: ["Actif", "Inactif"],
            readOnly: false
          }
        ]
      }
    }
  },
  created() {
    this.getData();
    this.getCompanies();
    this.initEditedItem();
  },
  mounted() {
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;
  },
  computed: {
    FormIsValid() {
      return (
          this.editedItem.companyId !== "" &&
          this.editedItem.plafondJour > 0 &&
          this.editedItem.quotePartCompany >= 0 &&
          this.editedItem.montantRechargeMois >= 0 &&
          this.editedItem.modePlafond !== "" &&
          this.editedItem.nombreRepasParMois > 0
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.companyId !== "" &&
          this.editedItem.plafondJour > 0 &&
          this.editedItem.quotePartCompany >= 0 &&
          this.editedItem.montantRechargeMois >= 0 &&
          this.editedItem.modePlafond !== "" &&
          this.editedItem.nombreRepasParMois > 0
      );
    }
  },
  methods: {
    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      this.modifier = "Modifications subvention de " + rowT[1];
    },
    extractNumericValue(str) {
      if (!str) {
        console.log("Valeur vide trouvée, retour de 0");
        return 0;
      }

      console.log("Extraction de la valeur numérique de:", str);

      // Vérifier si la valeur est déjà un nombre
      if (typeof str === 'number') {
        console.log("C'est déjà un nombre:", str);
        return str;
      }

      // Extraire uniquement les chiffres et le point décimal
      const match = str.match(/[\d.]+/);
      const result = match ? parseFloat(match[0].replace(/\./g, '')) : 0;

      console.log("Valeur extraite:", result);
      return result;
    },
    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      console.log("Données complètes de la ligne sélectionnée:", rowT);

      const subventionId = rowT[0];
      this.editedItem.id = subventionId;
      this.editedItem.nomEntreprise = rowT[1];

      // Utilisez directement l'ID d'entreprise stocké
      this.editedItem.companyId = this.companyIds[subventionId];
      console.log("ID de subvention:", subventionId);
      console.log("ID d'entreprise associé (depuis companyIds):", this.editedItem.companyId);

      // En plus, vérifiez aussi l'ancienne méthode pour comparer
      const company = this.companies.find(c => c.name.toUpperCase() === rowT[1]);
      const oldCompanyId = company ? company.id : "";
      console.log("ID d'entreprise trouvé par nom:", oldCompanyId);

      // Nouveaux champs
      this.editedItem.modePlafond = rowT[2];
      this.editedItem.nombreRepasParMois = rowT[3];

      // Extraction des valeurs numériques des champs formatés (indices mis à jour)
      this.editedItem.plafondJour = this.extractNumericValue(rowT[4]);
      this.editedItem.quotePartCompany = this.extractNumericValue(rowT[5]);
      this.editedItem.montantRechargeMois = this.extractNumericValue(rowT[6]);

      this.editedItem.resetEnfOfMonth = rowT[7];
      this.editedItem.allowedOrderNextMonth = rowT[8];
      this.editedItem.creationDate = rowT[9];
      this.editedItem.disabled = rowT[10] === "Inactif";

      console.log("État complet de l'objet editedItem:", JSON.stringify(this.editedItem));
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    show() {
      this.$modal.show('modal-fade');
    },
    hide() {
      this.$modal.hide('modal-fade');
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
      this.refresh();
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_subvention_rules/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            // Réinitialiser companyIds
            this.companyIds = {};

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            newObj.forEach((item) => {
              // Stocker l'ID d'entreprise associé à chaque subvention
              this.companyIds[item["id"]] = item["dtoWalletCompany"].id;

              console.log("Mapping ID subvention -> ID entreprise:", item["id"], "->", item["dtoWalletCompany"].id);

              tabArray.push([
                item["id"],
                item["dtoWalletCompany"].name.toUpperCase(),
                item["modePlafond"] || "JOURNALIER",
                item["nombreRepasParMois"] || 20,
                item["plafondJour"],
                item["quotePartCompany"],
                item["montantRechargeMois"],
                item["resetEnfOfMonth"],
                item["allowedOrderNextMonth"],
                this.datefull(item["creationDate"]),
                !item["disabled"] ? "Actif" : "Inactif"
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch((error) => {
            console.error("Erreur lors de la récupération des subventions:", error);
            this.loading = false
          });
    },
    getCompanies() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_companies/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            if (response.data.status === 200) {
              const companies = response.data.datas.map(company => ({
                id: company.id,
                name: company.name
              }));
              this.companies = companies;
            }
          })
          .catch(error => {
            console.error("Erreur lors de la récupération des entreprises:", error);
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    close() {
      this.dialog = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertS(type) {
      this.typeS = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide()
        }
        this.typeS = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    onexport() { // On Click Excel download button
      this.loading = true
      // export json to Worksheet of Excel
      // only array possible
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Subventions") // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "Subventions.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
    initEditedItem() {
      this.editedItem = {
        id: "",
        companyId: "",
        nomEntreprise: "",
        plafondJour: 0,
        quotePartCompany: 0,
        montantRechargeMois: 0,
        resetEnfOfMonth: false,
        allowedOrderNextMonth: false,
        disabled: false,
        modePlafond: "JOURNALIER",
        nombreRepasParMois: 20,
        creationDate: ""
      };
    },
    createSubvention() {
      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const plafond_jour = parseInt(this.editedItem.plafondJour, 10);
      const quotePartCompany = parseInt(this.editedItem.quotePartCompany, 10);
      const montant_rechargeMois = parseInt(this.editedItem.montantRechargeMois, 10);
      const reset_end_of_month = this.editedItem.resetEnfOfMonth;
      const allowed_order_next_month = this.editedItem.allowedOrderNextMonth;
      const mode_plafond = this.editedItem.modePlafond;
      const nombre_repas_par_mois = parseInt(this.editedItem.nombreRepasParMois, 10);
      const company_id = this.editedItem.companyId;
      const sender_id = sessionStorage.getItem("accountId");

      // URL correspondant à l'API backend
      const url = `${baseUrl}/wallet/add_wallet_subvention_rules/${plafond_jour}/${quotePartCompany}/${montant_rechargeMois}/${reset_end_of_month}/${allowed_order_next_month}/${mode_plafond}/${nombre_repas_par_mois}/${company_id}/${sender_id}`;

      console.log("URL de création:", url);

      apiClient
          .post(url)
          .then(res => {
            console.log("Réponse de l'API:", res.data);
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.close();
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.alert = true;
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            console.error("Erreur lors de la création:", err);
            this.alert = true;
            this.text = typeof err === 'object' ? JSON.stringify(err) : err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },
    updateSubvention() {
      this.loading = true;

      // Assurez-vous que l'ID est un nombre
      const subvention_id = parseInt(this.editedItem.id, 10);

      if (isNaN(subvention_id)) {
        this.alert = true;
        this.color = "#F44336";
        this.text = "ID de subvention invalide: " + this.editedItem.id;
        this.loading = false;
        this.showAlertS('warning');
        return;
      }

      // Assurez-vous que les montants sont des nombres valides
      const plafond_jour = parseInt(this.editedItem.plafondJour, 10);
      const quotePartCompany = parseInt(this.editedItem.quotePartCompany, 10);
      const montant_rechargeMois = parseInt(this.editedItem.montantRechargeMois, 10);
      const nombre_repas_par_mois = parseInt(this.editedItem.nombreRepasParMois, 10);

      console.log("Valeurs validées:", {
        plafond_jour,
        quotePartCompany,
        montant_rechargeMois,
        nombre_repas_par_mois
      });

      if (isNaN(plafond_jour) || isNaN(quotePartCompany) || isNaN(montant_rechargeMois) || isNaN(nombre_repas_par_mois)) {
        this.alert = true;
        this.color = "#F44336";
        this.text = "Les montants doivent être des nombres valides";
        this.loading = false;
        this.showAlertS('warning');
        return;
      }

      const baseUrl = this.$store.getters.user.baseUrl;
      const reset_end_of_month = this.editedItem.resetEnfOfMonth;
      const allowed_order_next_month = this.editedItem.allowedOrderNextMonth;
      const mode_plafond = this.editedItem.modePlafond;
      const sender_id = sessionStorage.getItem("accountId");

      // URL mise à jour avec tous les nouveaux champs
      const url = `${baseUrl}/wallet/update_wallet_subvention_rules/${subvention_id}/${plafond_jour}/${quotePartCompany}/${montant_rechargeMois}/${reset_end_of_month}/${allowed_order_next_month}/${mode_plafond}/${nombre_repas_par_mois}/${sender_id}`;

      console.log("URL de mise à jour complète:", url);

      apiClient
          .post(url)
          .then(res => {
            console.log("Réponse de l'API:", res.data);
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.alert = true;
              this.color = "#F44336";
              this.alert = true;
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            console.error("Erreur lors de la mise à jour:", err);
            this.alert = true;
            this.text = typeof err === 'object' ? JSON.stringify(err) : err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de la subvention.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              let obj = {};

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]];
              console.log("Objet à modifier dans afterChangeMe:", obj);
              console.log("ID de la subvention à modifier:", obj[0]);

              if (changes[0][1] === 10) {  // Colonne "Statut" est maintenant à l'index 10
                // Toggle statut Actif/Inactif
                let urlTmp = "";
                if (changes[0][3] === "Actif") {
                  urlTmp = `${this.$store.getters.user.baseUrl}/wallet/enable_wallet_subvention_rules/${obj[0]}/${sessionStorage.getItem("accountId")}`;
                } else if (changes[0][3] === "Inactif") {
                  urlTmp = `${this.$store.getters.user.baseUrl}/wallet/disable_wallet_subvention_rules/${obj[0]}/${sessionStorage.getItem("accountId")}`;
                }

                console.log("URL d'activation/désactivation:", urlTmp);

                apiClient
                    .post(urlTmp)
                    .then(res => {
                      dialog.close();
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.color = "#009688";
                        this.text = res.data.message;
                        this.showAlert('info');
                      } else {
                        this.alert = true;
                        this.color = "#F44336";
                        this.alert = true;
                        this.text = res.data.message;

                        let myData = this.$refs.hotTable.hotInstance.getData();
                        myData[changes[0][0]][changes[0][1]] = changes[0][2];
                        this.$refs.hotTable.hotInstance.loadData(myData);

                        this.showAlert('warning');
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      this.alert = true;
                      this.color = "#F44336";
                      this.text = err.data ? err.data.message : err;
                      this.loading = false;

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    });
              } else if (changes[0][1] === 7 || changes[0][1] === 8) {
                // Changement de checkbox (remise à zéro ou autorisation commande) - indices mis à jour
                const company = this.companies.find(c => c.name.toUpperCase() === obj[1]);
                const company_id = company ? company.id : "";

                if (!company_id) {
                  dialog.close();
                  this.alert = true;
                  this.color = "#F44336";
                  this.text = "Entreprise non trouvée";
                  this.loading = false;
                  this.showAlert('warning');
                  return;
                }

                // Extraire les valeurs en tenant compte de la modification
                const mode_plafond = obj[2];
                const nombre_repas_par_mois = obj[3];
                const plafond_jour = this.extractNumericValue(obj[4]);
                const quotePartCompany = this.extractNumericValue(obj[5]);
                const montant_rechargeMois = this.extractNumericValue(obj[6]);

                // Appliquer la modification pour les checkboxes
                const reset_end_of_month = (changes[0][1] === 7) ? changes[0][3] : obj[7];
                const allowed_order_next_month = (changes[0][1] === 8) ? changes[0][3] : obj[8];
                const sender_id = sessionStorage.getItem("accountId");

                // URL mise à jour avec tous les nouveaux paramètres
                const url = `${this.$store.getters.user.baseUrl}/wallet/update_wallet_subvention_rules/${obj[0]}/${plafond_jour}/${quotePartCompany}/${montant_rechargeMois}/${reset_end_of_month}/${allowed_order_next_month}/${mode_plafond}/${nombre_repas_par_mois}/${sender_id}`;

                console.log("URL de mise à jour (checkbox) avec nouveaux champs:", url);

                apiClient
                    .post(url)
                    .then(res => {
                      dialog.close();
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.color = "#009688";
                        this.text = res.data.message;
                        this.showAlert('info');
                      } else {
                        this.alert = true;
                        this.color = "#F44336";
                        this.alert = true;
                        this.text = res.data.message;

                        let myData = this.$refs.hotTable.hotInstance.getData();
                        myData[changes[0][0]][changes[0][1]] = changes[0][2];
                        this.$refs.hotTable.hotInstance.loadData(myData);

                        this.showAlert('warning');
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      this.alert = true;
                      this.color = "#F44336";
                      this.text = err.data ? err.data.message : err;
                      this.loading = false;

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    });
              } else {
                // Modification d'un des autres champs (indices mis à jour)
                const company = this.companies.find(c => c.name.toUpperCase() === obj[1]);
                const company_id = company ? company.id : "";

                if (!company_id) {
                  dialog.close();
                  this.alert = true;
                  this.color = "#F44336";
                  this.text = "Entreprise non trouvée";
                  this.loading = false;
                  this.showAlert('warning');
                  return;
                }

                // Pour tous les champs modifiables, construire TOUTES les valeurs
                let mode_plafond, nombre_repas_par_mois, plafond_jour, quotePartCompany, montant_rechargeMois;

                // Appliquer la modification selon la colonne changée, sinon prendre valeur actuelle
                mode_plafond = (changes[0][1] === 2) ? changes[0][3] : obj[2];
                nombre_repas_par_mois = (changes[0][1] === 3) ? changes[0][3] : obj[3];
                plafond_jour = (changes[0][1] === 4) ? this.extractNumericValue(changes[0][3]) : this.extractNumericValue(obj[4]);
                quotePartCompany = (changes[0][1] === 5) ? this.extractNumericValue(changes[0][3]) : this.extractNumericValue(obj[5]);
                montant_rechargeMois = (changes[0][1] === 6) ? this.extractNumericValue(changes[0][3]) : this.extractNumericValue(obj[6]);

                const reset_end_of_month = obj[7];
                const allowed_order_next_month = obj[8];
                const sender_id = sessionStorage.getItem("accountId");

                // URL CORRIGÉE avec TOUS les paramètres requis
                const url = `${this.$store.getters.user.baseUrl}/wallet/update_wallet_subvention_rules/${obj[0]}/${plafond_jour}/${quotePartCompany}/${montant_rechargeMois}/${reset_end_of_month}/${allowed_order_next_month}/${mode_plafond}/${nombre_repas_par_mois}/${sender_id}`;

                console.log("URL CORRIGÉE (autres champs) avec TOUS les paramètres:", url);
                console.log("Valeurs envoyées:", {
                  subvention_id: obj[0],
                  plafond_jour,
                  quotePartCompany,
                  montant_rechargeMois,
                  reset_end_of_month,
                  allowed_order_next_month,
                  mode_plafond,
                  nombre_repas_par_mois,
                  sender_id
                });

                apiClient
                    .post(url)
                    .then(res => {
                      dialog.close();
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.color = "#009688";
                        this.text = res.data.message;
                        this.showAlert('info');
                        this.getData(); // Rafraîchir pour obtenir les valeurs formatées
                      } else {
                        this.alert = true;
                        this.color = "#F44336";
                        this.alert = true;
                        this.text = res.data.message;

                        let myData = this.$refs.hotTable.hotInstance.getData();
                        myData[changes[0][0]][changes[0][1]] = changes[0][2];
                        this.$refs.hotTable.hotInstance.loadData(myData);

                        this.showAlert('warning');
                      }
                    })
                    .catch((err) => {
                      this.loading = false;
                      dialog.close();

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.alert = true;
                      this.color = "#F44336";
                      this.text = err.data ? err.data.message : err;
                      this.loading = false;
                      this.showAlert('warning');
                    });
              }
            })
            .catch(() => {
              this.loading = false;
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      console.log("Ligne à supprimer:", rowId);
      console.log("ID de la subvention à supprimer:", rowId[0]);

      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la subvention.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            // S'assurer que nous utilisons le bon ID pour la suppression
            const subventionId = rowId[0];
            const url = `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_subvention_rules_by_id/${subventionId}/${sessionStorage.getItem("accountId")}`;

            console.log("URL de suppression:", url);

            apiClient
                .delete(url)
                .then(res => {
                  console.log("Réponse de l'API de suppression:", res.data);
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);

                    this.color = "#F44336";
                    this.alert = true;
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  console.error("Erreur lors de la suppression:", error);
                  dialog.close();
                  this.loading = false;
                  this.alert = true;
                  this.color = "#F44336";
                  this.text = typeof error === 'object' ? JSON.stringify(error) : error;
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
          });
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    }
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.centered-input >>> input {
  text-align: center !important;
}

/* Sélecteurs très spécifiques pour le problème de v-select */
.v-select__selections {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.v-select__selection {
  margin: 0 !important;
  text-align: center !important;
}

/* Pour s'assurer que la case principale reste alignée au centre */
.v-input--selection-controls__input {
  margin: 0 auto !important;
}

/* Forcer l'alignement central du texte dans les sélections */
.v-select .v-select__selection--comma {
  margin: 0 auto !important;
  text-align: center !important;
  width: 100% !important;
  overflow: visible !important;
}

/* Forcer le centrage dans tous les cas */
.v-select .v-input__slot div {
  text-align: center !important;
}

/* Centrer les cases à cocher */
.mx-auto.text-center >>> .v-input__slot {
  justify-content: center !important;
}

.mx-auto.text-center >>> .v-label {
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
}
</style>